/*
 * This uses scroll positions to affix an element to the top of the viewport.
 * It's useful for making an element `position: fixed` when needed.
 * If you need to detect when a `position: sticky` element becomes sticky, see _sticky.js.
 */

import each from 'lodash/each'
import throttle from 'lodash/throttle'

const stickyElementSelector = '[data-sticky-scroll]'
const stickyClassname = 'is-scroll-stuck'

let observers = []

function setupStickyScrollObserver(el) {
  if (el.hasAttribute('data-sticky-scroll-initialized')) {
    return
  }
  const style = getComputedStyle(el)
  // + 1 is required to get the element to intersect with the browser window.
  const stickyOffset = (parseInt(style.getPropertyValue('--sticky-offset'), 10) || 0) + 1
  let lastTop = null
  let isStuck = false

  const checkStickiness = () => {
    const winScrollY = window.scrollY
    if (lastTop === null) {
      lastTop = el.getBoundingClientRect().top + winScrollY
    }

    const shouldBeStuck = winScrollY >= lastTop - stickyOffset
    // console.log(
    //   `shouldBeStuck: ${shouldBeStuck}`,
    //   `isStuck ${isStuck}`,
    //   `scrollY ${winScrollY} now ${lastTop - stickyOffset}`,
    // )
    if (shouldBeStuck !== isStuck) {
      isStuck = shouldBeStuck
      el.classList.toggle(stickyClassname, shouldBeStuck)
    }
  }

  checkStickiness()
  window.addEventListener('scroll', throttle(checkStickiness, 30))

  el.setAttribute('data-sticky-scroll-initialized', '1')
}

function setupStickyScrollObservers(container) {
  if (!container) {
    return
  }

  // Initialize existing elements:

  const existingEls = container.querySelectorAll(stickyElementSelector)
  if (existingEls.length) {
    each(existingEls, (el) => {
      setupStickyScrollObserver(el)
    })
  }

  // Observe new elements:

  const observer = new MutationObserver((mutations) => {
    each(mutations, (mutation) => {
      each(mutation.addedNodes, (node) => {
        if (node.nodeType !== 1) {
          return
        }

        const els = node.querySelectorAll(stickyElementSelector)
        if (!els.length) {
          return
        }

        each(els, (el) => {
          setupStickyScrollObserver(el)
        })
      })
    })
  })

  observer.observe(container, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false,
  })
}

function destroyStickyScrollObservers() {
  observers.forEach((observer) => observer.disconnect())
  observers = []
}

export { setupStickyScrollObservers, destroyStickyScrollObservers }
